<template>
    <div class="medical-column">
        <div class="header-follow" v-if="subscribes && subscribes !== null && subscribes.length">
            <div class="header-follow-title">我的关注</div>
            <div class="header-follow-content" v-if="subscribes">
                <div v-for="item in subscribes" :key="item.id" class="header-follow-content-item" @click.stop="goDetail(item)">
                    <van-badge :dot="item.showRedPoint">
                        <van-image :src="item.logo" />
                    </van-badge>
                    <span class="header-follow-content-item-title">
                        {{ item.title }}
                    </span>
                </div>
            </div>
            <div v-else></div>
        </div>

        <van-index-bar :index-list="indexList" class="medical-index-bar" highlight-color="#222222">
            <div v-for="item in indexeList" :key="item.id">
                <van-index-anchor v-if="item.py && item.isOnly" :index="item.py" />
                <van-cell @click.prevent="goDetail(item)">
                    <template #title>
                        <van-badge :dot="item.showRedPoint">
                            <van-image :src="item.Logo" />
                        </van-badge>
                    </template>
                    <template #default>
                        <div class="content-left">
                            <div>{{ item.title }}</div>
                            <div>{{ item.subscribe_count }}关注</div>
                            <div>{{ item.desc }}</div>
                        </div>
                        <div class="content-right">
                            <van-button v-if="item.is_subscribe" round type="default" @click.stop="handleStatus(item)">已关注</van-button>
                            <van-button v-else round type="primary" @click.stop="handleStatus(item)">
                                <img src="@/assets/medical/medical-follow.svg" />
                                关注
                            </van-button>
                        </div>
                    </template>
                </van-cell>
            </div>
        </van-index-bar>
    </div>
</template>

<script>
import Interface from '@/util/interface'

export default {
    data() {
        return {
            indexeList: [],
            // 我的关注
            subscribes: [],
            pageID: '',
            type: false,
            isPageHide: true
        }
    },

    computed: {
        indexList() {
            const result = [
                'A',
                'B',
                'C',
                'D',
                'E',
                'F',
                'G',
                'H',
                'I',
                'J',
                'K',
                'L',
                'M',
                'N',
                'O',
                'P',
                'Q',
                'R',
                'S',
                'T',
                'U',
                'V',
                'W',
                'X',
                'Y',
                'Z'
            ]
            return result
        }
    },
    methods: {
        handleStatus(row) {
            if (!row.is_subscribe) {
                this.pageID = row.id
                this.fetch('subscribe')
                return
            }
            this.$dialog
                .confirm({
                    title: '提醒',
                    message: '确定取消关注吗？',
                    confirmButtonText: '确定',
                    className: 'dly-dialog'
                })
                .then(() => {
                    this.type = true
                    this.pageID = row.id
                    this.fetch('subscribe')
                })
                .catch(() => {
                    console.log(1)
                })
        },
        goDetail(row) {
            this.$router.push({
                name: 'medical-column-list',
                params: { id: row.id }
            })
        },
        fetch(scene) {
            if (scene === 'list') {
                Interface.getData('get', Interface.medical.list, this.page).then(res => {
                    if (res.code === 0) {
                        this.subscribes = res.data.subscribes
                        const tmp = [
                            'A',
                            'B',
                            'C',
                            'D',
                            'E',
                            'F',
                            'G',
                            'H',
                            'I',
                            'J',
                            'K',
                            'L',
                            'M',
                            'N',
                            'O',
                            'P',
                            'Q',
                            'R',
                            'S',
                            'T',
                            'U',
                            'V',
                            'W',
                            'S',
                            'Y',
                            'Z'
                        ]
                        tmp.forEach(item => {
                            const result = res.data.list.find(fitem => fitem.py === item)
                            if (result) {
                                result.isOnly = true
                            }
                        })

                        this.indexeList = res.data.list
                    }
                })
            } else if (scene === 'subscribe') {
                Interface.getData('get', Interface.medical.subscribe + this.pageID).then(res => {
                    if (res.code === 0) {
                        if (this.type) {
                            this.$toast.success('取消关注成功')
                            this.type = false
                            this.pageID = null
                        } else {
                            this.$toast.success('关注成功')
                        }
                        this.fetch('list')
                    } else {
                        this.$toast(res.message)
                    }
                })
            }
        }
    },
    created() {
        this.fetch('list')
        Interface.getShareInfo(this,"医学专栏","","点击查看更多", 41)

        let source_type = Interface.getUrl(window.location.href)
        if (source_type) {
            Interface.mFootPrint('', 41,0, 0, source_type, '医学专栏')
        } else {
            Interface.mFootPrint('',41,'','',0, '医学专栏')
        }
    },
    activated() {
        this.fetch('list')
    }
}
</script>

<style lang="scss">
// 自定义弹出框的内容
.dly-dialog {
    width: 270px;
    height: 164px;
    background: #ffffff;
    border-radius: 8px;
    padding-bottom: 5px;

    .van-dialog__header {
        text-align: center;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #222222;
        line-height: 22px;
        padding-top: 20px;
        padding-bottom: 12px;
    }

    .van-dialog__content .van-dialog__message {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #404040;
        line-height: 20px;
        margin-bottom: 30px;
        padding: 0px;
    }

    .van-dialog__footer {
        padding: 0px 29px 0px 29px;

        .van-dialog__cancel {
            .van-button__content {
                width: 100px;
                height: 40px;
                background: #f7f7f7;
                border-radius: 20px;
                margin: 0 auto;
                padding: 0px;

                .van-button__text {
                    font-size: 14px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #999999;
                    line-height: 20px;
                }
            }
        }

        .van-dialog__confirm {
            .van-button__content {
                width: 100px;
                height: 40px;
                background: #d3172e;
                border-radius: 20px;
                margin: 0 auto;
                margin-left: 12px;

                .van-button__text {
                    font-size: 14px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #ffffff;
                    line-height: 20px;
                }
            }
        }
    }

    .van-dialog__cancel {
        border: none;
        text-align: center;
    }

    .van-hairline--top::after {
        border: none;
    }

    .van-hairline--left::after {
        border: none;
    }
}
</style>

<style lang="scss" scoped>
@import './index.scss';
</style>



// WEBPACK FOOTER //
// src/views/medical-column/index.vue